export default __webpack_public_path__ + "static/media/6.93a7746e.jpg";